import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';

import type { IAppState } from 'shared/common/state';
import type { IEtazhiBlackFridayBannerData, IEtazhiBlackFridayDataByPlatform } from 'shared/types/etazhiBlackFriday';

export const selectEtazhiBlackFridayBannerData = (state: IAppState): IEtazhiBlackFridayDataByPlatform | null => {
  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  if (!isEnabled) {
    return null;
  }

  const data = state.config.get<IEtazhiBlackFridayBannerData>('proApp.etazhiBlackFridayBannerData');

  return data?.desktop || null;
};
